import styled from 'styled-components'

import { FormStatus } from '@types'

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  gap: 12px;
  padding: 3px 1px;
`

export const StatusContainer = styled.div`
  width: 22px;
`

export const Status = styled.div<{ status: FormStatus }>`
  display: flex;
  width: ${({ status }) => (status == FormStatus.StatusToDo ? 22 : 20)}px;
  height: ${({ status }) => (status == FormStatus.StatusToDo ? 22 : 20)}px;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  border: ${({ status }) => (status == FormStatus.StatusToDo ? 0 : 2)}px solid var(--Persistent-White, #fff);
  background: ${({ status }) =>
    status == FormStatus.StatusDone ? '#2FB609' : status == FormStatus.StatusInProgress ? '#FF8F00' : 'transparent'};

  /* Raised */
  box-shadow: ${({ status }) =>
    status == FormStatus.StatusToDo ? 0 : '0px 2px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)'};

  box-sizing: border-box;

  width: 20px;
  height: 20px;
`

export const ItemLabel = styled.label<{ labelColor: 'dark' | 'light'; selectable: boolean }>`
  color: ${({ labelColor }) => (labelColor === 'dark' ? '#14171f' : '#4D5874')};

  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  color: ${({ selectable }) => (selectable ? 'pointer' : 'default')};
  cursor: pointer;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
